import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function CustomerForm() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('id');
  const isEditMode = !!customerId;
  const [formData, setFormData] = useState({
    name: isEditMode ? 'Acme Corporation' : '',
    email: '',
    phone: '',
    address: '',
    city: '',
    country: 'Sri Lanka',
    status: 'active' as const
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Saving customer:', formData);
    navigate('/customers');
  };
  return <div className="space-y-6" data-id="element-3699">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-3700">
        <button onClick={() => navigate('/customers')} className="flex items-center gap-2 text-gray-600 hover:text-gray-900" data-id="element-3701">
          <ArrowLeftIcon size={20} data-id="element-3702" />
          Back to Customers
        </button>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-3703">
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3704">
          <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-3705">
            {isEditMode ? 'Edit Customer' : 'Create New Customer'}
          </h2>
          <div className="space-y-6" data-id="element-3706">
            {/* Basic Information */}
            <div data-id="element-3707">
              <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-3708">
                Basic Information
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3709">
                <div data-id="element-3710">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3711">
                    Customer Name *
                  </label>
                  <input type="text" required value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-3712" />
                </div>
                <div data-id="element-3713">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3714">
                    Email *
                  </label>
                  <input type="email" required value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-3715" />
                </div>
                <div data-id="element-3716">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3717">
                    Phone
                  </label>
                  <input type="tel" value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} placeholder="+94 77 123 4567" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-3718" />
                </div>
                <div data-id="element-3719">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3720">
                    Status
                  </label>
                  <select value={formData.status} onChange={e => setFormData({
                  ...formData,
                  status: e.target.value as 'active' | 'inactive'
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-3721">
                    <option value="active" data-id="element-3722">Active</option>
                    <option value="inactive" data-id="element-3723">Inactive</option>
                  </select>
                </div>
              </div>
            </div>
            {/* Address */}
            <div data-id="element-3724">
              <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-3725">
                Address
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3726">
                <div className="md:col-span-2" data-id="element-3727">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3728">
                    Street Address
                  </label>
                  <input type="text" value={formData.address} onChange={e => setFormData({
                  ...formData,
                  address: e.target.value
                })} placeholder="123 Business Street" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-3729" />
                </div>
                <div data-id="element-3730">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3731">
                    City
                  </label>
                  <input type="text" value={formData.city} onChange={e => setFormData({
                  ...formData,
                  city: e.target.value
                })} placeholder="Colombo" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-3732" />
                </div>
                <div data-id="element-3733">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3734">
                    Country
                  </label>
                  <input type="text" value={formData.country} onChange={e => setFormData({
                  ...formData,
                  country: e.target.value
                })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-3735" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-3" data-id="element-3736">
          <button type="button" onClick={() => navigate('/customers')} className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-3737">
            Cancel
          </button>
          <button type="submit" className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-3738">
            {isEditMode ? 'Update Customer' : 'Create Customer'}
          </button>
        </div>
      </form>
    </div>;
}